/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import PropTypes from 'prop-types';
import Button from 'gatsby-core-theme/src/components/atoms/button/button';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import useTranslate from '~hooks/useTranslate/useTranslate';
import ArrowIcon from '../../../../images/icons/arrow';

import styles from './not-found.module.scss';

const NotFound = ({
  imageWidth = 165,
  imageHeight = 96,
  buttonIcon = <ArrowIcon color="#060E26" />,
}) => (
  <div className={styles.wrapper || ''}>
    <div className={styles.container || ''}>
      <LazyImage
        src="/images/404.png"
        alt="not found background"
        width={imageWidth}
        height={imageHeight}
        className={styles?.logo404 || ''}
      />
      <h2>{useTranslate('main_404_title', 'Oops, Something Went Wrong.')}</h2>
      <div className={styles.textBlock || ''}>
        {useTranslate(
          'second_404_title',
          'It seems the page you are looking for does not exist. Try these useful links:'
        )}
      </div>
      <Button to="/" btnText={useTranslate('home_btn', 'Return to Home')} icon={buttonIcon} />
    </div>
  </div>
);

NotFound.propTypes = {
  imageWidth: PropTypes.number,
  imageHeight: PropTypes.number,
  buttonIcon: PropTypes.shape({}),
};

export default NotFound;
